import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box, Container, Paper, Typography } from '@mui/material'

import useTranslations from '../../i18n/useTranslations'

import ClientCentersView from './ClientCenters/View'
import useStyles from './styles'

const SHOW_CONTACT_FORM = false

const UserZoneView = ({ username, centres, contactDataSlot, passwordSlot }) => {
  const t = useTranslations()
  const classes = useStyles()

  return (
    <>
      <Typography variant="h1" className={clsx('mainTitle', classes.mainTitle)}>
        {t('user-zone:welcome', { name: username ?? 'unnamed' })}
      </Typography>
      <Typography variant="body1" className={classes.explanation}>
        {t('user-zone:explanation')}
      </Typography>
      <Paper elevation={1} className={classes.paper}>
        <Container className={classes.mainContainer}>
          {centres ? (
            <>
              <Typography
                variant="h2"
                className={clsx('decorator', classes.subtitle)}
              >
                {t('user-zone:client-code')}
              </Typography>
              <ClientCentersView rows={centres} />
            </>
          ) : null}
          {SHOW_CONTACT_FORM ? (
            <>
              <Typography
                variant="h2"
                className={clsx('decorator', classes.subtitle)}
              >
                {t('user-zone:contact-data')}
              </Typography>
              <Typography variant="body1" className={classes.explanation}>
                {t('user-zone:contact-explanation')}
              </Typography>
              <Box className={classes.fieldTextContainer}>
                {contactDataSlot}
              </Box>
            </>
          ) : null}
          <Typography
            variant="h2"
            className={clsx('decorator', classes.subtitle)}
            style={{
              // REVIEW Temporary development styling
              marginTop: '64px',
            }}
          >
            {t('user-zone:password')}
          </Typography>
          <Box className={classes.fieldTextContainer}>{passwordSlot}</Box>
        </Container>
      </Paper>
    </>
  )
}

UserZoneView.propTypes = {
  username: PropTypes.string,
  centres: PropTypes.arrayOf(
    PropTypes.shape({
      clientCode: PropTypes.string.isRequired,
      clientName: PropTypes.string.isRequired,
    }),
  ),
  contactDataSlot: PropTypes.element.isRequired,
  passwordSlot: PropTypes.element.isRequired,
}

export default UserZoneView
